import { defaultState } from './activity-interfaces';


export const activityInitialState = {
	clientsLogsData: defaultState,
	isClientsLogsDataLoading: false,
};
